import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { FormattedMessage } from "react-intl";
import { RotateLoader } from "react-spinners";
import { myUtilities, myGlobals } from "../../Utils";

class CreditCardPaymentLoading extends React.Component {
  render() {
    return (
      <Container className="payment-check-container payment-loader">
        <Row className="payment-check-marginTop">
          <Col></Col>
        </Row>
        <Row>
          <Col className="payment-check-element check-pay-trifecta">
            <RotateLoader
              size={15}
              sizeUnit={"px"}
              color={"#000000"}
              loading={true}
            />
          </Col>
            <div className="loading-gif-trifecta"></div>
        </Row>
        <Row className="payment-check-space">
          <Col></Col>
        </Row>
        <Row>
          <Col className="payment-check-element">
          {myGlobals.isACHFlow?
              myUtilities.accountSpecificLanguage(
                "ACH.Fetching",
                "Please wait getting ACH details"
              )
               :
          myGlobals.isDCFlow
              ? myUtilities.accountSpecificLanguage(
                  "DebitCard.Fetching",
                  "Please wait getting debit card details"
                )
              : myUtilities.accountSpecificLanguage(
                  "CreditCard.Fetching",
                  "Please wait getting credit card details"
                )}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CreditCardPaymentLoading;
